import { throwError } from 'rxjs';
import { LoggerService } from './../services/logger.service';
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler, Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable()
export class LoggerErrorHandler implements ErrorHandler {
  constructor(private loggerService: LoggerService) {}
  handleError(error: Error) {
    if(error)
    {
        try{
          var agent = navigator.userAgent;
          var jsonText = '';
          if(agent)
          {
              jsonText = JSON.stringify(agent);
          }
          this.loggerService.logger(jsonText + "@" + error.message + "@" + error.name + "@" + error.stack, 'GlobalErrorTracking');
        }catch (e) {
          throw e;
        }
    }
    throw error;
  }
}